import { render } from "./SelectedBlock.vue?vue&type=template&id=80af9580"
import script from "./SelectedBlock.vue?vue&type=script&lang=js"
export * from "./SelectedBlock.vue?vue&type=script&lang=js"

import "./SelectedBlock.vue?vue&type=style&index=0&id=80af9580&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__